<section [style.background-image]="'url(' + intermediateFilter.photo + ')'" (click)="openFilter()">
    <div class="background-gradient" [class.selected]="selectedIntermediateFilterId == intermediateFilter.id"></div>
    <app-intermediate-filter-list
        [intermediateFilter]="intermediateFilter"
        [selectedIntermediateFilterId]="selectedIntermediateFilterId"
        [filters]="filters()"
        (closeFilterEvent)="closeIntermediateFilter()"
    ></app-intermediate-filter-list>
</section>